<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row pt10">
				<div class="col-md-6 text-center">
					<div class="card bg-purple border-0">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21 pointer" @click="openModal('panel')">CASH</div>
								<div class="font-size-18">{{ numeral(totals.panel).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<div class="card bgGreen border-0">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21 pointer" @click="openModal('pacific')">CAJA SHIELD</div>
								<div class="font-size-18">{{ numeral(totals.pacific - totalCanceledPacific).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-md-6 text-center">
					<div class="card bgRls border-0">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21 pointer" @click="openModal('rls')">CAJA SHIELD</div>
								<div class="font-size-18">{{ numeral(totals.rls - totalCanceledRLS).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div> -->
			</div>

			<div class="row">
				<div class="col-md-3">
					<b>FECHA</b>
					<!-- <a-icon type="reload" @click="onResetFilter('defaultDate')" :style="{ fontSize: '14px', color: 'red' }" /> -->
					<a-range-picker
						:inputReadOnly="true"
						style="width: 100%"
						@change="initModule"
						v-model="filters.defaultDate"
						:default-value="filters.defaultDate"
						:value-format="'YYYY-MM-DD'"
						:format="'YYYY-MM-DD'"
					/>
				</div>
				<div class="col-md-9 pt20 text-right">
					<a-button class="btn btn-success ml5" icon="reload" @click="initModule" />
				</div>
				<!-- <div class="col-md-4">
					<b># de Ticket</b>
					<a-input v-model="filters.ticket" v-mask="'######'" v-on:keyup.enter="searchByTicket" allowClear @change="onResetTicket" />
				</div> -->
			</div>

			<a-table
				:columns="columns"
				:dataSource="tickets"
				class="pt20"
				:pagination="false"
				:rowClassName="
					(_record, index) => {
						if (_record.active < 1) {
							return 'bgRed'
						} else {
							if (_record.from_panel) {
								return 'bg-purple'
							}
						}
					}
				"
			>
				<div slot="id" slot-scope="record">
					{{ record.id }}
					<div v-if="record.service_order">
						<a-tag color="red"> ODS {{ record.service_order }} </a-tag>
					</div>
					<div>
						{{ record.fullName }}
					</div>
				</div>
				<div slot="cart" slot-scope="record">
					<div class="text-uppercase text-left">
						<b>{{ record.customer_name }}</b>
					</div>
					<div class="text-left">
						<div v-for="(element, index) in record.cart" :key="index">
							<div>{{ element.quantity }}x {{ element.product.sku }} - {{ element.product.label }}</div>
						</div>
					</div>
				</div>

				<div slot="total" slot-scope="record">
					{{ numeral(record.total).format('$0,0.00') }}
					<div>
						<span v-if="record.payment_cash > 0 && !record.cart">
							<a-tag color="green">
								{{ numeral(record.payment_cash).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Efectivo
								</span>
							</a-tag>
							<br />
						</span>
						<span v-else-if="record.payment_cash > 0 && record.cart">
							<a-tag color="green">
								{{ numeral(record.payment_cash).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Efectivo
								</span>
							</a-tag>
							<br />
						</span>
						<div v-if="record.payment_bank_terminal > 0">
							<a-tag color="blue">
								{{ numeral(record.payment_bank_terminal).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/credit-card.png" height="20" />
									Terminal
								</span>
							</a-tag>
							<br />
						</div>
						<span v-if="record.payment_transfer > 0">
							<a-tag color="orange">
								{{ numeral(record.payment_transfer).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/money-transfer.png" height="20" />
									Transferencias
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_paypal > 0">
							<a-tag color="purple">
								{{ numeral(record.payment_paypal).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/paypal.png" height="20" />
									PayPal
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_mercadopago > 0">
							<a-tag color="cyan">
								{{ numeral(record.payment_mercadopago).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/mercadopago.png" height="20" />
									MercadoPago
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_aplazo > 0 && !record.cart">
							<a-tag color="gray" style="color: #000">
								{{ numeral(record.payment_aplazo).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Aplazo
								</span>
							</a-tag>
							<br />
						</span>
					</div>
				</div>

				<div slot="created_at" slot-scope="record">
					<div>{{ moment(record.created_at).tz('America/Mexico_City').format('DD-MM-YYYY') }} hrs.</div>
					<div>{{ moment(record.created_at).tz('America/Mexico_City').format('HH:mm:ss') }} hrs.</div>
				</div>
				<div slot="action" slot-scope="record">
					<a-tooltip title="Re-imprimir Ticket" v-if="record.from_panel || record.from_rls">
						<a-button class="btn btn-success" size="small" icon="printer" @click="onPrintTicket(record)" />
					</a-tooltip>
					<div v-else>{{ record.pacific }}</div>
					<div v-if="record.active < 1">CANCELADO</div>
					<div v-if="isSuperAdmin">
						<div>
							<b>{{ record.COD_CLI }}</b>
						</div>
						<div>{{ record.NOM_CLI }}</div>
					</div>
					<a-tooltip title="Facturar Venta" v-if="!record.billed && !record.from_panel && moment(record.created_at).isSame(moment(), 'month')">
						<a-button class="btn btn-warning" size="small" icon="file-pdf" @click="onBillSale(record.id)" />
					</a-tooltip>
					<a-tooltip title="Descargar PDF" v-if="record.facturama_id">
						<a-button class="btn btn-primary" size="small" icon="file-pdf" @click="downloadInvoice(record.facturama_id, 'pdf', false)" />
					</a-tooltip>
					<a-tooltip title="Descargar XML" v-if="record.facturama_id">
						<a-button class="btn btn-info" size="small" icon="file-text" @click="downloadInvoice(record.facturama_id, 'xml', false)" />
					</a-tooltip>
					<a-tooltip title="Enviar por Email" v-if="record.facturama_id">
						<a-button class="btn btn-danger" size="small" icon="mail" @click="sendInvoiceByEmail(record.facturama_id)" />
					</a-tooltip>
					<!-- <a-tooltip title="Refacturar Ticket" v-if="record.facturama_id">
						<a-button class="btn btn-warning" style="margin-left: 5px" size="small" icon="reload" @click="onRefactorInvoice(record.id)" />
					</a-tooltip> -->
				</div>
			</a-table>
		</a-spin>
		<ticketComponent
			v-if="ticketVisible"
			:ticketData="ticket.ticketData"
			:advances="ticket.advances"
			:theSalesman="ticket.fullName"
			:cart="ticket.cart"
			:paymentData="ticket.paymentData"
			:hasGiftTicket="giftTicket"
			:serviceOrder="ticket.serviceOrder"
			:orderDiscount="ticket.orderDiscount"
			:client="localClient"
		/>
		<a-modal :visible="modalDetailBoutiqueVisible" title="Detalle de ingresos" :closable="false" width="70%">
			<template slot="footer">
				<a-button key="back" @click="onCloseModal('boutique')"> Cerrar </a-button>
			</template>
			<div class="row">
				<div class="col-md-12 text-center">
					<div class="card bg-primary border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">TOTAL DE INGRESOS</div>
								<div class="font-size-18">
									{{ numeral(totals[modalType] - (modalType == 'pacific' ? totalCanceledPacific : totalCanceledRLS)).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<div class="card bg-success border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Efectivo</div>
								<div class="font-size-18">
									{{ numeral(bankTerminalOperations[modalType]?.paymentMethods.cash).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<div class="card bg-info border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Digital</div>
								<div class="font-size-18">
									{{ numeral(totalDigital).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 text-center">
					<div class="card bg-info border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Terminal Bancaria</div>
								<div class="font-size-18">
									{{ numeral(bankTerminalOperations[modalType]?.credit + bankTerminalOperations[modalType]?.credit_msi + bankTerminalOperations[modalType]?.debit).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 text-center">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Terminal Crédito</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.credit).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 text-center">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Terminal Crédito 3 MSI</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.credit_msi).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 text-center">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Terminal Débito</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.debit).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center" :class="modalType == 'pacific' ? 'col-md-3' : 'col-md-4'">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Transferencia</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.paymentMethods?.transfer || 0).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center" :class="modalType == 'pacific' ? 'col-md-3' : 'col-md-4'">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">PayPal</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.paymentMethods?.paypal || 0).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center" :class="modalType == 'pacific' ? 'col-md-3' : 'col-md-4'">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">MercadoPago</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.paymentMethods?.mercadopago).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-3 text-center" v-if="modalType == 'pacific'">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Aplazo</div>
								<div class="font-size-18">{{ numeral(bankTerminalOperations[modalType]?.paymentMethods?.aplazo.total).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</a-modal>
		<a-modal
			:visible="modalBillingVisible"
			:title="billingSuccess ? 'Factura Generada' : 'Seleccionar Uso de CFDI'"
			@ok="handleBillingOk"
			@cancel="handleBillingCancel"
			:okText="billingSuccess ? 'Cerrar' : 'Facturar'"
			:cancelText="billingSuccess ? null : 'Cancelar'"
			:confirmLoading="spinnerLoader"
			:closable="!spinnerLoader"
			:maskClosable="!spinnerLoader"
		>
			<div class="row" v-if="!billingSuccess">
				<div class="col-md-12">
					<label><b>Cliente:</b></label>
					<div v-if="selectedClient && selectedClient.id">
						<a-tag closable @close="onRemoveClient" color="blue" style="font-size: 14px; padding: 5px 10px; height: auto; text-transform: uppercase">
							{{ selectedClient.full_name || `${selectedClient.client_name} ${selectedClient.client_surname}` }}
						</a-tag>
					</div>
					<div v-else>
						<a-button type="dashed" block @click="modalSearchClientVisible = true" :disabled="spinnerLoader"> <a-icon type="search" /> Buscar/Seleccionar Cliente </a-button>
					</div>
				</div>

				<div class="col-md-12 pt10">
					<a-checkbox v-model="billingData.customBillingData" :disabled="spinnerLoader"> Facturar a otra razón social </a-checkbox>
				</div>

				<div v-if="billingData.customBillingData" class="col-md-12 pt10">
					<div class="row">
						<div class="col-md-6 pt10">
							<label><b>RFC:</b></label>
							<a-input v-model="billingData.rfc" placeholder="RFC" style="text-transform: uppercase" :disabled="spinnerLoader" />
						</div>
						<div class="col-md-6 pt10">
							<label><b>Nombre / Razón Social:</b></label>
							<a-input v-model="billingData.businessName" placeholder="Nombre o Razón Social" style="text-transform: uppercase" :disabled="spinnerLoader" />
						</div>
						<div class="col-md-6 pt10">
							<label><b>Código Postal:</b></label>
							<a-input v-model="billingData.zipCode" placeholder="C.P." v-mask="'#####'" :disabled="spinnerLoader" />
						</div>
						<div class="col-md-6 pt10">
							<label><b>Régimen Fiscal:</b></label>
							<a-select v-model="billingData.taxRegime" style="width: 100%" placeholder="Seleccione Régimen" :disabled="spinnerLoader">
								<a-select-option v-for="regime in taxRegimes" :key="regime.id" :value="regime.id"> {{ regime.id }} - {{ regime.description }} </a-select-option>
							</a-select>
						</div>
					</div>
				</div>

				<div class="col-md-12 pt10">
					<label><b>Uso de CFDI:</b></label>
					<a-select v-model="billingData.cfdiUse" style="width: 100%" placeholder="Seleccione el uso de CFDI" :disabled="spinnerLoader">
						<a-select-option value="G03">G03 - Gastos en general</a-select-option>
						<a-select-option value="G01">G01 - Adquisición de mercancías</a-select-option>
						<a-select-option value="S01">S01 - Sin efectos fiscales</a-select-option>
					</a-select>
				</div>
			</div>
			<div class="row" v-else>
				<div class="col-md-12 text-center">
					<a-alert message="¡Factura creada con éxito!" type="success" show-icon />
					<div class="pt20">
						<p>Ya puedes descargar los archivos de la factura:</p>
						<a-button class="btn btn-primary mr5" icon="file-pdf" @click="downloadInvoice(billingDataResponse.pdf, 'pdf', true)"> Descargar PDF </a-button>
						<a-button class="btn btn-info" icon="file-text" @click="downloadInvoice(billingDataResponse.xml, 'xml', true)"> Descargar XML </a-button>
					</div>
				</div>
			</div>
			<template v-if="billingSuccess" slot="footer">
				<a-button key="submit" type="primary" @click="handleBillingCancel"> Cerrar </a-button>
			</template>
		</a-modal>

		<!-- Búsqueda de cliente -->
		<a-modal :visible="modalSearchClientVisible" title="Búsqueda de Cliente" :closable="true" width="60%" @cancel="modalSearchClientVisible = false">
			<template slot="footer">
				<a-button key="back" @click="modalSearchClientVisible = false"> Cancelar </a-button>
				<a-button key="submit" class="btn btn-success" @click="addClientToBilling"> Seleccionar </a-button>
			</template>
			<clientsQuickSearchComponent ref="clientsQuickSearchComponent" :visible="modalSearchClientVisible" :showAddButton="false" @selectedRecord="onSelectedClient" />
		</a-modal>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import numeral from 'numeral'
import ticketComponent from '@/components/ticket'
import _ from 'lodash'
import utilities from '@/services/utilities'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
import clientsQuickSearchComponent from '@/components/clients/quickSearch'
import { taxRegimes } from '@/constants'

const dateFormat = 'YYYY-MM-DD'

export default {
	name: 'posDashboardView',
	components: {
		ticketComponent,
		clientsQuickSearchComponent,
	},
	directives: {
		mask,
	},
	computed: {
		...mapGetters('pos', ['filters']),
		...mapGetters('users', ['usersList']),
		...mapGetters('user', ['user']),
		...mapGetters('customers', ['customersList']),
		isSuperAdmin() {
			let allowedUserPermition = [1, 3]
			return !!allowedUserPermition.includes(this.user.user_id)
		},
		isUserAdmin() {
			return this.user.is_admin ? true : false
		},
		spinnerLoaderLabel() {
			return this.$store.state.pos.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.pos.spinnerLoader
		},
		totalDigital() {
			if (utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'paymentMethods'], false)) {
				return (
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'credit']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'credit_msi']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'debit']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'paymentMethods', 'mercadopago']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'paymentMethods', 'paypal']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'paymentMethods', 'transfer']), 0).value() +
					numeral(utilities.objectValidate(this.bankTerminalOperations, [this.modalType, 'paymentMethods', 'aplazo']), 0).value()
				)
			}
			return 0
		},
		totalCanceledPacific() {
			return (
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'credit']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'credit_msi']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'debit']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'paymentMethods', 'cash']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'paymentMethods', 'mercadopago']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'paymentMethods', 'paypal']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'paymentMethods', 'transfer']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['pacific', 'canceled', 'paymentMethods', 'aplazo']), 0).value()
			)
		},
		totalCanceledRLS() {
			return (
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'credit']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'credit_msi']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'debit']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'paymentMethods', 'cash']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'paymentMethods', 'mercadopago']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'paymentMethods', 'paypal']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'paymentMethods', 'transfer']), 0).value() +
				numeral(utilities.objectValidate(this.bankTerminalOperations, ['rls', 'canceled', 'paymentMethods', 'aplazo']), 0).value()
			)
		},
	},
	data() {
		return {
			filterType: 'range',
			filterBranchOffice: '',
			modalDetailDigitalVisible: false,
			modalDetailBoutiqueVisible: false,
			dateFormat,
			columns: [
				{
					title: 'Ticket/Cajero',
					scopedSlots: { customRender: 'id' },
					align: 'center',
					width: '15%',
				},
				{
					title: 'Carrito',
					scopedSlots: { customRender: 'cart' },
					align: 'center',
					width: '45%',
				},
				{
					title: 'Total',
					scopedSlots: { customRender: 'total' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Fecha',
					scopedSlots: { customRender: 'created_at' },
					align: 'center',
					width: '15%',
				},
				{
					title: 'Acciones',
					scopedSlots: { customRender: 'action' },
					align: 'right',
					width: '15%',
				},
			],
			ticket: {},
			ticketVisible: false,
			giftTicket: false,
			localClient: {},
			tickets: [],
			bankTerminalOperations: {},
			totals: {
				panel: 0,
				pacific: 0,
				rls: 0,
			},
			modalType: 'pacific',
			modalBillingVisible: false,
			billingSuccess: false,
			newFacturamaId: null,
			billingData: {
				cfdiUse: 'G03',
				ticketId: null,
				ticketRecord: null,
				customBillingData: false,
				rfc: '',
				businessName: '',
				zipCode: '',
				taxRegime: null,
				clientId: null,
			},
			billingDataResponse: {},
			modalSearchClientVisible: false,
			selectedClient: null,
			taxRegimes,
		}
	},
	mounted() {
		this.getData()
		if (this.usersList.length == 0) {
			this.$store.dispatch('users/GET')
		}
		if (this.customersList.length == 0) {
			this.$store.dispatch('customers/GET')
		}
	},
	methods: {
		moment,
		numeral,
		onResetFilter(key) {
			this.$store.dispatch('pos/RESET_ONE_FILTER', key)
			this.initModule()
		},
		initModule(date, dateString) {
			//
			let payload = {}

			if (this.filterType == 'range') {
				if (!!dateString && dateString.length) {
					payload = {
						startDate: moment(dateString[0]).format('YYYY-MM-DD'),
						endDate: moment(dateString[1]).format('YYYY-MM-DD'),
					}
				} else {
					payload = {
						startDate: moment(this.filters.defaultDate[0]).format('YYYY-MM-DD'),
						endDate: moment(this.filters.defaultDate[1]).format('YYYY-MM-DD'),
					}
				}
			} else {
				payload = {
					startDate: moment(this.filters.defaultDate[0]).format('YYYY-MM-DD'),
					endDate: moment(this.filters.defaultDate[0]).format('YYYY-MM-DD'),
				}
			}

			if (!!utilities.objectValidate(this, 'filterBranchOffice', false)) {
				payload.branch_office_id = this.filterBranchOffice
			}

			payload = {
				...payload,
				cashier: this.filters.cashier,
				paymentMethod: this.filters.paymentMethod,
			}

			this.tickets = []

			// console.log('payload-->', payload)
			this.$store.dispatch('pos/GET_TICKETS', payload).then((response) => {
				// console.log('GET_TICKETS-->', response);
				let totals = {
					panel: 0,
					pacific: 0,
					rls: 0,
				}

				// ordenamos por fecha la lista de tickets
				let tickets = _.orderBy(response.tickets, ['created_at'], ['desc'])

				tickets.forEach((element) => {
					// console.log('element-->', element);
					if (element.from_pacific) {
						totals.pacific += numeral(element.total).value()
					}
					if (element.from_panel) {
						totals.panel += numeral(element.total).value()
					}
					if (element.from_rls) {
						totals.rls += numeral(element.total).value()
					}
				})

				this.tickets = _.cloneDeep(tickets)
				this.bankTerminalOperations = _.cloneDeep(response.bankTerminalOperations)
				// console.log('response.bankTerminalOperations--->', response.bankTerminalOperations);
				this.totals = _.cloneDeep(totals)
			})
		},
		getData() {
			this.initModule()
		},
		onPrintTicket(record, giftTicket = false) {
			this.giftTicket = giftTicket

			// Verificar si cart es string o ya es un objeto
			let cart = []
			if (utilities.objectValidate(record, 'cart', false)) {
				if (typeof record.cart === 'string') {
					try {
						cart = JSON.parse(record.cart)
					} catch (e) {
						console.error('Error parsing cart:', e)
						cart = []
					}
				} else {
					cart = record.cart
				}
			}

			this.ticket = {
				fullName: record.fullName,
				cart: cart,
				ticketData: {
					id: record.id,
					created_at: record.created_at,
					validator: record.validator,
					branchOfficeId: record.branch_office_id,
					from_rls: record.from_rls,
				},
				paymentData: {
					payment_bank_terminal: record.payment_bank_terminal,
					payment_cash: record.payment_cash,
					payment_mercadopago: record.payment_mercadopago,
					payment_paypal: record.payment_paypal,
					payment_transfer: record.payment_transfer,
					payment_advance: record.payment_advance,
					payment_billpocket: record.payment_billpocket,
					payment_aplazo: record.payment_aplazo,
				},
			}

			if (utilities.objectValidate(record, 'client', false)) {
				this.localClient = {
					id: record.client,
					client_last_surname: utilities.objectValidate(record, 'client_last_surname', ''),
					client_name: record.client_name,
					client_surname: record.client_surname,
					email: utilities.objectValidate(record, 'email', ''),
					primary_phone: utilities.objectValidate(record, 'primary_phone', ''),
				}
			} else {
				this.localClient = {}
			}

			this.ticketVisible = true

			setTimeout(() => {
				this.$htmlToPaper('reprintPosTicket')
			}, 500)

			setTimeout(() => {
				this.ticketVisible = false
			}, 3000)
		},
		onBillSale(id) {
			// Buscar el ticket completo en la lista
			const ticketRecord = this.tickets.find((ticket) => ticket.id === id)

			if (!ticketRecord) {
				this.$notification.error({
					message: 'Facturación',
					description: 'No se encontró el ticket',
				})
				return
			}

			// Validar que la fecha esté dentro del mes actual
			if (!moment(ticketRecord.created_at).isSame(moment(), 'month')) {
				this.$notification.warning({
					message: 'Facturación',
					description: 'Solo se pueden facturar ventas del mes actual',
				})
				return
			}

			// Guardar los datos del ticket y abrir el modal
			this.billingData.ticketId = id
			this.billingData.ticketRecord = ticketRecord
			this.billingData.cfdiUse = 'G03' // Valor por defecto
			this.billingData.customBillingData = false
			this.billingData.rfc = ''
			this.billingData.businessName = ''
			this.billingData.zipCode = ''
			this.billingData.taxRegime = null
			this.billingData.clientId = null

			this.billingSuccess = false
			this.newFacturamaId = null
			this.selectedClient = null

			// Si el ticket ya tiene un cliente, intentar cargarlo
			if (ticketRecord.client) {
				const client = this.customersList.find((c) => c.id == ticketRecord.client)
				if (client) {
					this.selectedClient = _.cloneDeep(client)
					this.billingData.clientId = client.id

					// Pre-cargar datos de facturación si los tiene
					if (client.rfc) {
						this.billingData.rfc = client.rfc
						this.billingData.businessName = client.business_name || client.full_name
						this.billingData.zipCode = client.zip_code
						this.billingData.taxRegime = client.tax_regime_id
					}
				}
			}

			this.modalBillingVisible = true
		},
		handleBillingCancel() {
			if (this.billingSuccess) {
				this.initModule()
			}
			this.modalBillingVisible = false
			this.billingSuccess = false
			this.newFacturamaId = null
			this.billingData = {
				cfdiUse: 'G03',
				ticketId: null,
				ticketRecord: null,
				customBillingData: false,
				rfc: '',
				businessName: '',
				zipCode: '',
				taxRegime: null,
				clientId: null,
			}
		},
		handleBillingOk() {
			if (this.billingSuccess) {
				this.handleBillingCancel()
				return
			}

			if (!this.billingData.cfdiUse) {
				this.$notification.warning({
					message: 'Facturación',
					description: 'Debe seleccionar un uso de CFDI',
				})
				return
			}

			if (this.billingData.customBillingData) {
				if (!this.billingData.rfc || !this.billingData.businessName || !this.billingData.zipCode || !this.billingData.taxRegime) {
					this.$notification.warning({
						message: 'Facturación',
						description: 'Debe completar todos los datos mínimos para facturación',
					})
					return
				}
			}

			// Construir el payload
			const payload = {
				id: this.billingData.ticketId,
				cfdiUse: this.billingData.cfdiUse,
				clientId: this.selectedClient ? this.selectedClient.id : null,
			}

			if (this.billingData.customBillingData) {
				payload.customBillingData = {
					rfc: this.billingData.rfc.toUpperCase(),
					businessName: this.billingData.businessName.toUpperCase(),
					zipCode: this.billingData.zipCode,
					taxRegime: this.billingData.taxRegime,
				}
			}

			// Enviar la factura
			this.$store
				.dispatch('pos/CREATE_BILL', payload)
				.then((response) => {
					// console.log('Factura creada:', response)
					this.billingDataResponse = response.data
					this.billingSuccess = true
				})
				.catch((error) => {
					console.error('Error al crear factura:', error)
				})
		},
		onSelectedClient(record) {
			this.selectedClient = _.cloneDeep(record)
		},
		addClientToBilling() {
			this.$refs.clientsQuickSearchComponent.onSelectedRecord()

			if (!this.selectedClient) {
				return
			}

			this.billingData.clientId = this.selectedClient.id

			// Si el cliente seleccionado tiene datos de facturación, sugerirlos
			if (this.selectedClient.rfc) {
				this.billingData.rfc = this.selectedClient.rfc
				this.billingData.businessName = this.selectedClient.business_name || this.selectedClient.full_name
				this.billingData.zipCode = this.selectedClient.zip_code
				this.billingData.taxRegime = this.selectedClient.tax_regime_id
			}

			this.modalSearchClientVisible = false
		},
		onRemoveClient() {
			this.selectedClient = null
			this.billingData.clientId = null
		},
		filterOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		},
		downloadBill(id) {
			this.$store.dispatch('pos/DOWNLOAD_INVOICE', id)
		},
		async downloadInvoice(payloadFile, type, fromModal = false) {
			//
			let response = null

			if (!fromModal) {
				this.$store.commit('pos/SET_STATE', {
					spinnerLoader: true,
					spinnerLoaderLabel: 'Procesando descarga...',
				})

				try {
					// Obtener la factura desde la API usando el endpoint correcto
					response = await this.$store.dispatch('pos/OBTENER_FACTURA_DESCARGA', { type, id: payloadFile })

					if (!response) {
						throw new Error(`No se encontró el archivo ${type.toUpperCase()}`)
					}
				} catch (error) {
					console.error('Error al descargar factura:', error)
					Swal.fire({
						title: 'Error',
						text: 'Ocurrió un error al descargar la factura',
						icon: 'error',
						confirmButtonText: 'Cerrar',
					})
				} finally {
					this.$store.commit('pos/SET_STATE', {
						spinnerLoader: false,
					})
				}
			}

			// Descargar el archivo
			const base64Data = fromModal ? payloadFile : response.data[type]
			const filename = `factura.${type}`
			const mimeType = type === 'pdf' ? 'application/pdf' : 'application/xml'

			// Convertir base64 a blob
			const byteCharacters = atob(base64Data)
			const byteNumbers = new Array(byteCharacters.length)
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i)
			}
			const byteArray = new Uint8Array(byteNumbers)
			const blob = new Blob([byteArray], { type: mimeType })

			// Crear URL del blob
			const url = window.URL.createObjectURL(blob)

			// Crear elemento <a> para descargar
			const link = document.createElement('a')
			link.href = url
			link.download = filename
			document.body.appendChild(link)
			link.click()

			// Limpiar
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)

			await Swal.fire({
				title: 'Descarga exitosa',
				text: `El archivo ${type.toUpperCase()} se ha descargado correctamente`,
				icon: 'success',
				timer: 2000,
				timerProgressBar: true,
			})
		},
		sendInvoiceByEmail(id) {
			Swal.fire({
				title: '¿Enviar por email?',
				text: 'Se enviará la factura al correo del cliente',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Sí, enviar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.value) {
					this.$store.dispatch('pos/SEND_BILL_EMAIL', id)
				}
			})
		},
		onRefactorInvoice(id) {
			Swal.fire({
				title: '¿Refacturar ticket?',
				text: 'Se enviará la solicitud de refacturación para este ticket.',
				icon: 'question',
				showCancelButton: true,
				confirmButtonText: 'Sí, refacturar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.value) {
					this.$store.dispatch('pos/REFACTOR_BILL', id).then(() => {
						this.initModule()
					})
				}
			})
		},
		searchByTicket() {
			let payload = {
				ticket: this.filters.ticket,
			}

			this.$store.dispatch('pos/GET_TICKETS', payload)
		},
		onResetTicket(e) {
			if (e.target.value == '') {
				this.initModule()
			}
		},
		openModal(modalType) {
			this.modalDetailBoutiqueVisible = true
			this.modalType = modalType
		},
		onCloseModal(modal) {
			switch (modal) {
				case 'digital':
					this.modalDetailDigitalVisible = false
					break
				case 'boutique':
					this.modalDetailBoutiqueVisible = false
					break
			}
		},
		getAdvanceLabel(payload) {
			return JSON.parse(payload)[0].label
		},
		closeAdvance(ticket) {
			Swal.fire({
				title: 'Atención',
				text: '¿Deseas asociar el anticipo a una venta?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then(async (result) => {
				if (result.isConfirmed) {
					await Swal.fire({
						title: 'Ingresa # ticket de Pacific',
						input: 'text',
						inputValue: '',
						reverseButtons: true,
						showCancelButton: true,
						confirmButtonColor: '#41b883',
						confirmButtonText: 'Continuar',
						cancelButtonColor: '#f5222e',
						cancelButtonText: 'Cancelar',
						inputValidator: (value) => {
							if (!value) {
								return 'Es necesario ingresar # ticket de Pacific'
							}
						},
					}).then((resConfirm) => {
						if (resConfirm.isConfirmed) {
							//
							this.$store.dispatch('pos/CLOSE_ADVANCE', {
								ticket,
								pacific: resConfirm.value,
							})
						}
					})
				}
			})
		},
	},
}
</script>
